export default __webpack_public_path__ + "static/media/Nosotros_imagen2_1440.7c332cc3.jpg";